import React, { useEffect, useRef, useState } from 'react';
import { Modal, Box, ClickAwayListener, Tooltip, useMediaQuery } from '@mui/material';
import greenDot from '../../../assets/greendot.svg';
import redDot from '../../../assets/reddot.svg';
import starPic from '../../../assets/StarWhite.svg';
import CloseIcon from '../../../assets/svg/closeIcon';
import './FoodMenuDetailsModal.css';
import { useTranslation } from 'react-i18next';
import Tabbing from './Tabbing';
import Food1 from '../../../assets/OMFLogo.png';
import { IoPlayOutline } from 'react-icons/io5';
import { getOpenStatusFromAPI } from '../../../OpenStatus';

const FoodDetailsModal = ({
    open = false,
    handleClose = () => {},
    food,
    handleOrderClick = () => {},
    orderBtn = true,
    vendorId,
    vendorDistance
}) => {
    const { t } = useTranslation();
    const [animateModal, setAnimateModal] = useState(false);
    const [closing, setClosing] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);
    const videoRef = useRef(null);
    const [vendorStatus, setVendorStatus] = useState(false);
    const isMobile = useMediaQuery('(max-width:600px)');
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [vendorOpeningTime, setVendorOpeningTime] = useState();
    const [vendorOpeningDay, setVendorOpeningDay] = useState();
    const [pickupTooltipOpen, setPickupTooltipOpen] = useState(false);

    const checkStatus = () => {
        getOpenStatusFromAPI(vendorId)
            .then((data) => {
                setVendorStatus(data.status);
                setVendorOpeningTime(data.nextOpenTime);
                setVendorOpeningDay(data.nextOpenDay);
            })
            .catch((error) => {
                console.error('Error checking status:', error);
            });
    };
    
    useEffect(() => {
        checkStatus();
    }, []);

    const handleTooltipOpen = () => {
        if (vendorStatus !== 'open') {
            setTooltipOpen(true);
            setTimeout(() => {
                setTooltipOpen(false);
            }, 3000);
        }
    };

    const handleTooltipClose = () => {
        setTooltipOpen(false);
    };

    const handlePlay = (e) => {
        e.stopPropagation();
        if (videoRef.current) {
            videoRef.current.play()
                .then(() => {
                    setIsPlaying(true);
                })
                .catch((err) => {
                    console.error('Error playing video:', err);
                    setIsPlaying(false);
                });
        }
    };

    useEffect(() => {
        if (!open && videoRef.current) {
            videoRef.current.pause();
            setIsPlaying(false);
        }
    }, [open]);

    useEffect(() => {
        if (open) {
            const timer = setTimeout(() => {
                setAnimateModal(true);
            }, 100);
            return () => clearTimeout(timer);
        }
    }, [open]);
    
    useEffect(() => {
        if (open && food?.Avatar_key?.match(/\.(mp4|webm|ogg)$/i)) {
            if (food?.autoplay && videoRef.current) {
                videoRef.current
                    .play()
                    .then(() => setIsPlaying(true))
                    .catch((err) => {
                        console.error('Autoplay error:', err);
                        setIsPlaying(false);
                    });
            }
        } else if (!open && videoRef.current) {
            videoRef.current.pause();
            setIsPlaying(false);
        }
    }, [open, food]);
       

    return (
        <Modal
            open={open}
            onClose={()=>{ 
                setClosing(true);
                handleClose();
            }}
            style={{
                backdropFilter: 'blur(10px)',
                backgroundColor: '#2C3142B2 !important',
            }}
        >
            <Box className={`food-detail-popup ${animateModal ? 'animate' : ''} ${closing ? 'close' : ''}`}>
                <div className='food-image-container11'>
                    <div className='food-img'>
                        {food?.Avatar_key && (
                            <>
                                <div className='image-overlay'>
                                    <div className="food-model-media-wrapper">
                                        {food?.Avatar_key?.match(/\.(mp4|webm|ogg)$/i) ? (
                                            <div className="video-container1">
                                                <video
                                                    src={food?.Avatar_key}
                                                    muted
                                                    playsInline
                                                    // eslint-disable-next-line react/no-unknown-property
                                                    webkit-playsinline="true"
                                                    preload="metadata"
                                                    autoPlay={food?.autoplay}
                                                    className="food-video1"
                                                    ref={videoRef}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        if (videoRef.current.paused) {
                                                            videoRef.current.play()
                                                                .then(() => setIsPlaying(true))
                                                                .catch((err) => {
                                                                    console.error('Error playing video:', err);
                                                                    setIsPlaying(false);
                                                                });
                                                        } else {
                                                            videoRef.current.pause();
                                                            setIsPlaying(false);
                                                        }
                                                    }}
                                                    onEnded={() => {
                                                        videoRef.current.pause();
                                                        setIsPlaying(false);
                                                    }}
                                                    onPlay={() => {
                                                        setIsPlaying(true);
                                                    }}
                                                    onPause={() => {
                                                        setIsPlaying(false);
                                                    }}
                                                    onError={(e) => {
                                                        e.target.poster = Food1;
                                                    }}
                                                />
                                                {!isPlaying && (
                                                    <button onClick={(e) =>handlePlay(e)} className='play-btn'>
                                                        <IoPlayOutline color='white' fontSize={34} />
                                                    </button>
                                                )}
                                            </div>
                                        ) : (
                                            <img
                                                className='image'
                                                src={food?.Avatar_key || Food1}
                                                alt='Food img'
                                                onError={(e) => {
                                                    e.target.src = Food1;
                                                }}
                                            />
                                        )}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                    <div className='veg-nonveg-close-part'>
                        <div className='reddot-item-div'>
                            <img
                                className='item-reddot-order11'
                                src={food?.vegetarian ? greenDot : redDot}
                                alt='dot'
                            />
                            <h5 className='items-name-order'>{food?.menuItemName}</h5>
                        </div>
                        <div className='title-close-container'>
                            <CloseIcon
                                size={30}
                                color='#E13535'
                                onClick={handleClose}
                                className='close-icon'
                            />
                        </div>
                    </div>
                </div>
                <div className='food-details-container'>
                    <div className="food-details">
                        <div className='food-name-rating-container'>
                            <p className='food-name-text'>{food?.Item_name}</p>
                            <div className='img-rating-restaurant'>
                                <p className='rating-order'>{Number(food?.ItemAvgRating || 0)?.toFixed(1)}</p>
                                <img 
                                    className='star-img-order' 
                                    src={starPic} 
                                    alt='star'
                                    style={{marginBottom: '4px'}}
                                />
                            </div>
                        </div>
                        <div className='break-line12'></div>
                        <div className='restaurant-address-container'>
                            <div className='info-container'>
                                <p className='info-text'>{t('foodDetails.Restaurant')}</p>
                                <span className='two-dot'>:</span>
                                <p className='info-value'>{food?.VendorName}</p>
                            </div>
                            <div className='info-container'>
                                <p className='info-text'>{t('foodDetails.Address')}</p>
                                <span className='two-dot'>:</span>
                                <p className='info-value'>{food?.VendorAddress}</p>
                            </div>
                        </div>
                        <Tabbing
                            description={food?.Description}
                            ingredients={food?.Ingridents}
                            titleOne={t('foodDetails.Description')}
                            titleTwo={t('foodDetails.Ingredients')}
                        />
                    </div>


                    {isMobile && vendorStatus !== 'open' ? (
                        <ClickAwayListener onClickAway={handleTooltipClose}>
                            <Tooltip
                                onClose={handleTooltipClose}
                                open={tooltipOpen}
                                disableFocusListener
                                disableHoverListener
                                disableTouchListener
                                title={`Oops! ${food?.VendorName} is taking a break. They’ll be back ${(vendorOpeningTime && vendorOpeningDay) ? `at ${vendorOpeningDay} ${vendorOpeningTime}` : 'soon'}.`}
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            backgroundColor: '#E13535',
                                            color: '#ffffff',
                                            fontSize: '16px',
                                            lineHeight: '20px',
                                            borderRadius: '6px',
                                        },
                                    },
                                    arrow: {
                                        sx: {
                                            color: '#E13535',
                                        },
                                    }
                                }}
                                arrow
                            >
                                {orderBtn && (
                                    <div className='order-button-container'>
                                        <button
                                            className="order-popup-btn"
                                            onClick={handleTooltipOpen}
                                        >
                        Order
                                        </button>
                                    </div>
                                )}
                            </Tooltip>
                        </ClickAwayListener>
                    ) : isMobile && vendorStatus === 'open' && vendorDistance > 20 ? (
                        <ClickAwayListener onClickAway={() => setPickupTooltipOpen(false)}>
                            <Tooltip
                                onClose={() => setPickupTooltipOpen(false)}
                                open={pickupTooltipOpen}
                                disableFocusListener
                                disableHoverListener
                                disableTouchListener
                                title="Only pickup available."
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            backgroundColor: '#E13535',
                                            color: '#ffffff',
                                            fontSize: '16px',
                                            lineHeight: '20px',
                                            borderRadius: '6px',
                                        },
                                    },
                                    arrow: {
                                        sx: {
                                            color: '#E13535',
                                        },
                                    },
                                }}
                                arrow
                            >
                                {orderBtn && (
                                    <div className='order-button-container'>
                                        <button
                                            className="order-popup-btn"
                                            onClick={() => {
                                                setPickupTooltipOpen(true);
                                                setTimeout(() => {
                                                    setPickupTooltipOpen(false);
                                                }, 2000);
                                                setTimeout(() => {
                                                    handleOrderClick(food?.VendorName);
                                                }, 1000);
                                            }}
                                        >
                                        Order
                                        </button>
                                    </div>
                                )}
                            </Tooltip>
                        </ClickAwayListener>
                        
                    ) : vendorStatus === 'open' && vendorDistance > 20 ? (
                        <Tooltip
                            title="Only pickup available."
                            arrow
                            componentsProps={{
                                tooltip: {
                                    sx: {
                                        backgroundColor: '#E13535',
                                        color: '#ffffff',
                                        fontSize: '16px',
                                        lineHeight: '20px',
                                        borderRadius: '6px',
                                    },
                                },
                                arrow: {
                                    sx: {
                                        color: '#E13535',
                                    },
                                }
                            }}
                        >
                            {orderBtn && (
                                <div className='order-button-container'>
                                    <button
                                        className="order-popup-btn"
                                        onClick={() => {
                                            handleOrderClick(food?.VendorName);
                                        }}
                                    >
                                    Order
                                    </button>
                                </div>
                            )}
                        </Tooltip>
                    ) : (
                        <div className='order-button-container'>
                            {orderBtn && (
                                vendorStatus === 'open'  ? (
                                    <button
                                        className="order-popup-btn"
                                        onClick={() => handleOrderClick(food?.VendorName)}
                                    >
                Order
                                    </button>
                                ) : (
                                    <Tooltip
                                        title={`Oops! ${food?.VendorName} is taking a break. They’ll be back ${(vendorOpeningTime && vendorOpeningDay) ? `at ${vendorOpeningDay} ${vendorOpeningTime}` : 'soon'}.`}
                                        arrow
                                        componentsProps={{
                                            tooltip: {
                                                sx: {
                                                    backgroundColor: '#E13535',
                                                    color: '#ffffff',
                                                    fontSize: '16px',
                                                    lineHeight: '20px',
                                                    borderRadius: '6px',
                                                },
                                            },
                                            arrow: {
                                                sx: {
                                                    color: '#E13535',
                                                },
                                            }
                                        }}
                                    >
                                        <button className="order-popup-btn" disabled>
                    Order
                                        </button>
                                    </Tooltip>
                                )
                            )}
                        </div>
                    )}
                </div>
            </Box>
        </Modal>
    );
};

export default FoodDetailsModal;